import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {loadDashboardDatas} from '@app/4dm1n/tango-cards/_store/tango-cards.actions';
import {SetListMode} from '@app/4dm1n/users-list/store/users-list.actions';
import {RefreshList} from '@app/4dm1n/users-list/store/organizations/organizations-list.actions';


@Injectable({
  providedIn: 'root',
})
export class Adm1nResolver  {
  constructor(private store: Store<AppState>) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // console.log('************** >> Route : ', route);
    // console.log('************** >> State : ', state);
    // console.log(route.params);

    // console.log('route.routeConfig.path', route.routeConfig.path);

    switch (route.routeConfig.path) {

      case 'usersList/:userType':
        // Refresh organization list (si userType=Client mais bon...)
        this.store.dispatch(RefreshList());
        this.store.dispatch(SetListMode({userType: route.params.userType, addPublic: false}));

        break;

      case 'tangoCards':
        this.store.dispatch(loadDashboardDatas());
        break;

      default:
        return undefined;
    }
  }

}
